import type { FormFieldFeedback } from "@tellescope/types-models";

export interface FieldFeedbackProps {
  feedback?: FormFieldFeedback[];
  value: unknown;
}

/**
 * Renders the author-configured `field.feedback` messages whose `ifEquals` matches the
 * current answer — a scalar equality, or membership for multi-select answers.
 */
export const FieldFeedback = ({ feedback, value }: FieldFeedbackProps) => {
  const matched = (feedback ?? []).filter(
    ({ ifEquals }) => ifEquals === value || (Array.isArray(value) && value.includes(ifEquals))
  );

  if (matched.length === 0) return null;

  return (
    <div className="flex flex-col gap-1">
      {matched.map(({ ifEquals, display }) => (
        <p key={`${ifEquals}:${display}`} className="text-destructive text-base">
          {display}
        </p>
      ))}
    </div>
  );
};
